$(document).ready(function () {
    function appHeight() {
        document.documentElement.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
    };

    function headerHeight() {
        document.documentElement.style.setProperty('--header-height', "".concat($('header').outerHeight(), "px"));
    };
    
    appHeight();
    headerHeight();
});